import localforage from 'localforage'
import jwtDecode from 'jwt-decode'
import queryString from 'query-string'
import * as R from 'ramda'

const HtmlToReactParser = require('html-to-react').Parser

const htmlToReactParser = new HtmlToReactParser()
const noCache = queryString.parse(window.location.search).noCache ? true : false
export function unescapeHtmlTags(input) {
    //console.log(input)
    //input = input.replace(/&amp;iquest&#x3b;/g, "&iquest;")
    //input = input.replace(/&amp;oacute&#x3b;/g, "&oacute;")
    //input = input.replace(/&amp;iacute&#x3b;/g, "&iacute;")
    //input = input.replace(/&amp;eacute&#x3b;/g, "&eacute;")
    //input = input.replace(/&amp;nbsp&#x3b;/g, " ")
    //input = input.replace(/&amp;rsquo;/g, "'")
    input = input.replace(/&amp;&#x23;39&#x3b;/g, "'")
    input = input.replace(/&amp;&#x23;39;/g, "'")
    input = input.replace(/&amp;/g, "&")
    // input = input.replace(/&gt;/g, ">")
    // input = input.replace(/&lt;/g, "<")
    // input = input.replace(/&gt;/g, ">")
    // input = input.replace(/&lt;/g, "<")
    input = input.replace(/&#x2f;/g, "/")
    input = input.replace(/&#x3d;/g, "=")
    input = input.replace(/&quot;/g, '"')
    input = input.replace(/&#x3a;/g, ':')
    input = input.replace(/&#x3b;/g, ';')
    input = input.replace(/&#xa;/g, '')//line feed
    input = input.replace(/&#x9;/g, '')//carriage retrn
    input = input.replace(/&#x40;/g, '@')
    input = input.replace(/&#x21;/g, '!')
    input = input.replace(/&#163;/g, '£')
    input = input.replace(/&#x3f;/g, '?')
    input = input.replace(/&#39;/g, "'")
    input = input.replace(/&#x27;/g, "'")
    input = input.replace(/&#x28;/g, "(")
    input = input.replace(/&#x29;/g, ")")
    //console.log(input)
    return input
}

export function parseHtmlForReact(input, asSpan=true) {
    var c
    try {
        c = htmlToReactParser.parse( asSpan ? "<span>"+unescapeHtmlTags(input)+"</span>" : unescapeHtmlTags(input))
    } catch (e) {
        c = htmlToReactParser.parse( asSpan ? "<span>"+unescapeHtmlTags(stripOutHtml(input))+"</span>" : unescapeHtmlTags(stripOutHtml(input)) )
    }
    return c
}

export function stripOutHtml(input) {
    // thanks to https://robertnyman.com/roblab/javascript-remove-tags.htm
    // console.log(input)
    var strInputCode = input.replace(/&(lt|gt);/g, function (strMatch, p1) {
        return (p1 == "lt")? "<" : ">";
    })
    return strInputCode.replace(/<\/?[^>]+(>|$)/g, "")
}

export function localStorageSupported(mode) {
    console.log(`localStorageSupported noCache = ${noCache}, mode = ${mode}`)
    return (!noCache || mode === 'admin') && (localforage.supports(localforage.INDEXEDDB) || localforage.supports(localforage.WEBSQL) || localforage.supports(localforage.LOCALSTORAGE))
}

export function getRuntimeEnvironment() {
    console.log(window.location.hostname)
    /*
    if(window.location.hostname.indexOf("dev") !== -1 || window.location.hostname.indexOf("localhost") !== -1){
        return "dev-"
    } else {
        return ""
    }
    */

    //remove above once all environments set up
    const hName = window.location.hostname
    const arrNames = hName.split(".")
    if (arrNames.length === 1) {
        return "dev-"
    }
    const subDomain = arrNames[0]
    const arrSDomains = subDomain.split("-")
    if (arrSDomains.length === 2) {
        return arrSDomains[0]+"-"
    } else {
        return ""
    }
}

export function getCdnDomain() {
    const { hostname } = window.location
    let cdnDomain = ''
    if (hostname.match(/localhost|dev/gi)) {
        cdnDomain = 'cdn.staging.explori.com'
    } else {
        const domainArr = hostname.split('.')
        domainArr[0] = 'cdn'
        cdnDomain = domainArr.join('.')
    }
    return cdnDomain
}

export function getPrentDomain() {
    const parentDomain = window.location.hostname.split('.')
    parentDomain.shift()
    return parentDomain.join('.')
}

export function getApiHost(protocol) {
    const hName = window.location.hostname
    let apiHost = ''
    // if (hName.match(/dev/)) {
    //     const parts = hName.split(".")
    //     parts[0] = `gateway.${parts[0]}`
    //     apiHost = protocol + parts.join(".")
    // } else {
    //     const parts = hName.split(".")
    //     parts[0] = "gateway"
    //     apiHost = protocol + parts.join(".")
    // }
    const parts = hName.split('.')
    if (hName.match(/\.dev/) || hName.match(/localhost/)) {
        parts[1] = 'dev'
        return 'https://gateway.staging.explori.com'
    }
    parts[0] = 'gateway'
    apiHost = protocol + parts.join('.')
    console.log(`apihost: ${apiHost}`)
    // return 'https://gateway.v3.hosting.explori.com'
    return apiHost
}

//borrowed this from http://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
export function shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
    }
    return array
}

export function makeIterator(array) {
    var nextIndex = 0

    return {
       next: function() {
           return nextIndex < array.length ?
               {value: array[nextIndex++], done: false} :
               {done: true}
       },

       hasNext: function() {
           return nextIndex < array.length ? true : false
       }
    }
}

export function decodeToken(token) {
    console.log(token)
    return jwtDecode(token)
}

export function tokenIsValid(token) {
    console.log(token)
    return true
}

export function friendlyDateFormat(date) {
    const dateFormat = require('dateformat')
    return dateFormat(date, "dddd, mmmm dS, yyyy, h:MM:ss TT")
}

export function tmpSwapOutOtherQuestions(data) {
    var newData = {}
    var arrPages = data.pages
    arrPages.forEach(page => {
        if(page.hasOwnProperty("questions")){
            var arrQuestions = page.questions
            arrQuestions.forEach(question => {
                if(question.hasOwnProperty("sets")){
                    var arrSets = question.sets
                    arrSets.forEach(set => {
                        if(set.hasOwnProperty("options")){
                            var arrOptions = set.options
                            arrOptions.forEach(option => {
                                if(option.hasOwnProperty("question")){
                                    var other = option.question
                                    //delete(option.question)
                                    delete(other.id)
                                    delete(other.type)
                                    option["other"] = other

                                }
                            })
                        }
                    })
                }
            })
        }
    })
    //console.log(JSON.stringify(data))
    return data
}

export function hasWhiteSpace(s) {
    return /\s|%20/g.test(s)
}

export function removeWhiteSpace(s) {
    return s.replace(/\s|%20/g, '')
}

export function removeWhiteSpaceAndRefresh(href) {
    href = removeWhiteSpace(href)
    window.location.href = href
}

export function switchValueToUnit(switchValue) {
    const unitMap = {
        Pounds: 'lb',
        Estimate: undefined,
        Exact: undefined,
    }

    const defaultValue = R.isNil(switchValue)
        ? undefined
        : switchValue.toLowerCase()

    return R.hasPath([switchValue], unitMap)
        ? unitMap[switchValue]
        : defaultValue
}

export function switchValueToEstimate(switchValue) {
    const estimateMap = {
        Estimate: true,
        Exact: false,
    }

    return R.pathOr(undefined, [switchValue], estimateMap)
}
